// External libraries
import { css } from '@emotion/core';
import styled from '@emotion/styled';

// Internal modules
import {
  BUTTON_FOCUSED_COLOR,
  INFO_MESSAGE_BACKGROUND_COLOR_V2,
  LINK_HOVER_BOTTOM_PPREACT,
  LINK_HOVER_OPACITY_PPREACT,
  PRIMARY_COLOR,
  PRIMARY_COLOR_V2,
} from '@/styles';

const HeaderBackground = styled.div`
  &::before {
    content: '';
    display: block;
    height: 54px;
    left: 0;
    position: absolute;
    top: 0;
    width: 100vw;
    z-index: 0;
    background: #f7f5f0;
  }

  .top-cookie-banner-enabled &::before {
    top: ${props =>
      props.cookieBannerHeight ? props.cookieBannerHeight : 0}px;
  }
`;

const HeaderContainer = styled.div`
  margin-bottom: 32px;
  background: ${INFO_MESSAGE_BACKGROUND_COLOR_V2};
  @media screen and (min-width: 699px) and (max-width: 740px) {
    width: calc(100vw - 32px);
    padding-right: 16px;
  }
  @media screen and (max-width: 698px) {
    width: 100%;
  }
`;

const StyledHeader = styled.header`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  height: 'auto';
`;

/**
 * Necessary because IE 11 hates justify-content (and democracy)
 * If we just use `justify-content: space-between` on the <Header /> then
 * the logo will be right aligned. Using `flex-grow` to make the logo
 * container take up all empty space in the header which will result in
 * it extending to the left side of the header.
 */
const LogoContainer = styled.div`
  margin-top: ${props => (props.addTopMargin ? '2px' : '0px')};
  flex-grow: 1;
  z-index: 1;
  text-align: none;
  width: 33%;
`;

const LogInButton = styled.button`
  background-color: transparent;
  border: 1px solid ${PRIMARY_COLOR};
  border-radius: 15px;
  color: ${PRIMARY_COLOR};
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  min-width: 96px;
  padding: 6px 10px;
  z-index: 1;

  &:focus,
  &:hover {
    background-color: ${PRIMARY_COLOR};
    color: #fff;
    text-decoration: underline;
  }
`;

const CartButton = styled.button`
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid transparent;
  color: ${PRIMARY_COLOR_V2};
  cursor: ${props => (props.shouldLoadCartDropdown ? 'pointer' : 'default')};
  display: flex;
  font-size: 18px;
  font-weight: 700;
  outline: 0;
  padding: 1px;
  position: relative;

  &:focus {
    ${({ theme }) => css`
      ${theme.link.focus};
      text-decoration: underline;
    `}
  }

  &:hover {
    border-bottom: ${LINK_HOVER_BOTTOM_PPREACT};
    opacity: ${LINK_HOVER_OPACITY_PPREACT};
    color: ${BUTTON_FOCUSED_COLOR};
  }

  &:active {
    color: ${BUTTON_FOCUSED_COLOR};
  }
`;

const CartAmount = styled.span``;

const FlexboxContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: ${({ flexPosition }) => flexPosition};
  width: 33%;
`;

export {
  CartAmount,
  CartButton,
  FlexboxContainer,
  HeaderBackground,
  HeaderContainer,
  LogInButton,
  LogoContainer,
  StyledHeader,
};
